<template>
    <div class="multiViewsTabs">
        <div class="tabs-content" v-loading="isLoading">
            <el-tabs class="views-content" :active-name="modelViewsData[0].name" v-if="modelViewsData.length !== 0">
                <el-tab-pane
                    v-for="(viewFolder, index) in modelViewsData"
                    :key="index"
                    :label="viewFolder.name"
                    :name="viewFolder.name"
                >
                    <div class="viewmodel-card-group" v-if="viewFolder.children.length !== 0">
                        <el-scrollbar style="height: 100%;">
                            <div
                                v-for="(viewModel, index) in viewFolder.children"
                                :key="index"
                                class="viewmodel-img-container"
                            >
                                <div class="viewmodel-img-wrapper" @click="getModelView(viewModel)">
                                    <div class="viewmodel-img-shadow"></div>
                                    <div class="viewmodel-img-text">查看模型</div>
                                    <img class="viewmodel-img" :src="viewModel.imgUrl" />
                                </div>
                                <div class="viewmodel-img-footer">
                                    <div class="viewmodel-img-title" :title="viewModel.name">
                                        {{ viewModel.name }}
                                    </div>
                                    <div class="viewmodel-img-share">
                                        <i
                                            class="icon iconfont iconfenxiang viewmodel-icon"
                                            @click="shareModelView(viewModel)"
                                            title="分享"
                                        ></i>
                                    </div>
                                </div>
                            </div>
                        </el-scrollbar>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div class="empty-state-content" v-if="modelViewsData.length === 0">
                <el-empty description="没有视图"></el-empty>
            </div>
            <div class="convert-data-content" v-if="convertData">
                <el-divider></el-divider>
                <el-collapse accordion>
                    <el-collapse-item title="转换配置">
                        <div>{{ creatTime }}</div>
                        <div>{{ convertOptions }}</div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
    </div>
</template>

<script>
import RuntimeUtils from 'src/common/js/runtimeUtils';
import { base64UrlEncode } from 'src/utils/commonUtils';
import { CONVERT_CONFIG_KEY, CONVERT_CONFIG_VALUE } from 'src/utils/jobUtils';
import modelViewsShare from 'src/pages/devCenter/consoleLab/components/modelViews-share';

export default {
    name: 'multiViewsTabs',
    components: {
        modelViewsShare,
    },
    data() {
        return {
            modelViewsData: [
                // {
                //   name: 'aaa',
                //   children: [
                //      {
                //        cardName: 'aaa',
                //        imgUrl: ''
                //      },
            ],
            activeView: '',
            isLoading: true,
        };
    },
    props: {
        fileName: String, // 文件相关信息
        fileFormat: String,
        currentUrn: String,
        tokenData: String, // 浏览用的token
        convertType: String,
        jobType: String,
        version: String,
        convertData: Object,
    },
    computed: {
        creatTime() {
            return `转换时间：${this.convertData ? this.convertData.convertCreateTime : null}`;
        },
        convertOptions() {
            let convertMeta = '';
            if (this.convertData.convertMeta && this.fileFormat !== 'dwg') {
                switch (this.fileFormat) {
                    case 'rvt':
                        convertMeta = this.parseRvtConvertMeta();
                        break;
                    case 'ifc':
                        convertMeta = this.parseIfcConvertMeta();
                        break;
                    case 'nwd':
                        convertMeta = this.parseNwdConvertMeta();
                        break;
                    case 'skp':
                        convertMeta = this.parseSkpConvertMeta();
                        break;
                    default:
                        break;
                }
            } else if (this.fileFormat === 'dwg') {
                convertMeta = this.parseDwgConvertMeta();
            }
            return convertMeta;
        },
    },
    methods: {
        parseRvtConvertMeta() {
            let convertMeta = JSON.parse(this.convertData.convertMeta);
            let convertConfig = '';
            convertMeta.forEach((item) => {
                if (CONVERT_CONFIG_VALUE[item.v]) {
                    convertConfig += `${CONVERT_CONFIG_KEY[item.k]}：${CONVERT_CONFIG_VALUE[item.v]} `;
                } else {
                    convertConfig += `${CONVERT_CONFIG_KEY[item.k]}：${item.v} `;
                }
            });
            return convertConfig;
        },
        parseIfcConvertMeta() {
            let convertMeta = JSON.parse(this.convertData.convertMeta);
            let assembly = '否',
                noedgeline = '否',
                exportTexture = '否';
            convertMeta.forEach((item) => {
                if (item.k === '-assembly') {
                    // 兼容旧数据
                    if (typeof item.v === undefined || item.v === 'true') {
                        assembly = '是';
                    }
                    return;
                }
                if (item.k === '-noedgeline') {
                    if (typeof item.v === undefined || item.v === 'true') {
                        noedgeline = '是';
                    }
                    return;
                }
                if (item.k === '-exportTexture') {
                    if (typeof item.v === undefined || item.v === 'true') {
                        exportTexture = '是';
                    }
                    return;
                }
            });
            const convertConfig = `合并零件为构件：${assembly} 不导出边线数据：${noedgeline} 导出贴图：${exportTexture}  `;
            return convertConfig;
        },
        parseNwdConvertMeta() {
            let convertMeta = JSON.parse(this.convertData.convertMeta);
            let recalcuv = '否',
                noedgeline = '否',
                mergevertex = '否';
            convertMeta.forEach((item) => {
                if (item.k === '-recalcuv') {
                    if (typeof item.v === undefined || item.v === 'true') {
                        recalcuv = '是';
                    }
                    return;
                }
                if (item.k === '-noedgeline') {
                    if (typeof item.v === undefined || item.v === 'true') {
                        noedgeline = '是';
                    }
                    return;
                }
                if (item.k === '-mergevertex') {
                    if (typeof item.v === undefined || item.v === 'true') {
                        mergevertex = '是';
                    }
                    return;
                }
            });
            const convertConfig = `重新计算UV：${recalcuv} 执行顶点合并：${mergevertex} 不导出边线数据：${noedgeline}`;
            return convertConfig;
        },
        parseSkpConvertMeta() {
            let convertMeta = JSON.parse(this.convertData.convertMeta);
            let isExportLineSet = '否';
            convertMeta.forEach((item) => {
                if (item.k === '-isExportLineSet') {
                    if (item.v === 'true') {
                        isExportLineSet = '是';
                    }
                    return;
                }
            });
            const convertConfig = `是否导出边线：${isExportLineSet}`;
            return convertConfig;
        },
        parseDwgConvertMeta() {
            let viewtype = '';
            if (this.jobType && this.jobType.indexOf('3d') === -1) {
                viewtype = '二维图纸';
            } else {
                viewtype = '三维模型';
            }
            const convertConfig = `视图类型：${viewtype}`;
            return convertConfig;
        },
        getObvItemList(obvDocument) {
            const itemList = obvDocument.getViewableItems(obvDocument.getRootItem(), true);
            if (!itemList.length) {
                this.modelViewsData = [];
            } else {
                this.modelViewsData = itemList;
                this.getItemThumbnailUrl(obvDocument, this.modelViewsData);
            }
        },
        getLodItemList(obvDocument) {
            const itemList = obvDocument.getViewableItems(obvDocument.getRootItem());
            // TODO 兼容旧版流式数据
            if (!itemList.length) {
                this.$message({
                    type: 'warning',
                    message: '请重新转换生成流式视图，或在【LOD转换】页面查看旧版模型！',
                    duration: 6000,
                    offset: 50,
                });
                this.modelViewsData = [];
            } else {
                this.modelViewsData = itemList;
                this.getItemThumbnailUrl(obvDocument, this.modelViewsData);
            }
        },
        async initModelViews(token, urn) {
            const build = new OBV.Api.ObvBuilder();
            const applicationOptions = {
                getAccessToken(cb) {
                    cb(token, 60000);
                },
                serviceConfig: {
                    origin: `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}`,
                    apiContextPath: RuntimeUtils.instance.servicePath,
                },
                viewer3dConfig: {},
            };
            const application = await build.buildApplication(applicationOptions);
            let obvDocument = null;
            try {
                if (this.convertType === 'obv') {
                    obvDocument = await build.loadDocument(application, urn);
                    this.getObvItemList(obvDocument);
                } else if (this.convertType === 'lod') {
                    obvDocument = await build.loadDocument(application, urn, this.jobType);
                    this.getLodItemList(obvDocument);
                }
            } catch (err) {
                console.error('该模型没有视图数据，请重新转换！');
            }
            this.isLoading = false;
        },
        getItemThumbnailUrl(obvDocument, list) {
            const _self = this;
            list.forEach((listitem, listIndex) => {
                if (listitem.children.length !== 0) {
                    listitem.children.forEach((cardItem, cardIndex) => {
                        const thumbnailUrn = obvDocument.hasThumbnail(cardItem, true);
                        if (thumbnailUrn) {
                            obvDocument.getThumbnailUrl(cardItem).then((res) => {
                                if (res) {
                                    _self.modelViewsData[listIndex].children[cardIndex].imgUrl = res;
                                    if (listIndex === 0) {
                                        _self.$forceUpdate();
                                    }
                                }
                            });
                        } else {
                            _self.modelViewsData[listIndex].children[
                                cardIndex
                            ].imgUrl = `${process.env.STATIC}dataMock/fileMng/default-image.png`;
                        }
                    });
                }
            });
        },
        getModelView(viewModel) {
            // 创建临时的URL地址
            let tempURL;
            // 判断obv的版本v4 or v5
            if (this.version === 'v4') {
                const tempName = base64UrlEncode(`${this.fileName}-${viewModel.name}`);
                const tempCurrentUrn = base64UrlEncode(this.currentUrn);
                const tempGuid = base64UrlEncode(viewModel.guid);
                tempURL = `${window.location.origin}/devcenter/console/view?version=${this.version}&name=${tempName}&urn=${tempCurrentUrn}&guid=${tempGuid}`;
            } else {
                const tempName = base64UrlEncode(`${this.fileName}-${viewModel.name}`);
                const tempCurrentUrn = base64UrlEncode(this.currentUrn);
                const tempGuid = base64UrlEncode(viewModel.guid);
                const jobType = base64UrlEncode(this.jobType);
                // 判断查看模型的转换类型，是普通转换还是LOD转换
                if (this.convertType === 'lod') {
                    tempURL = `${window.location.origin}/devcenter/console/view?name=${tempName}&urn=${tempCurrentUrn}&guid=${tempGuid}&jobType=${jobType}`;
                } else if (this.convertType === 'obv') {
                    tempURL = `${window.location.origin}/devcenter/console/view?name=${tempName}&urn=${tempCurrentUrn}&guid=${tempGuid}&jobType=${jobType}`;
                }
            }
            window.open(tempURL, '_blank');
        },
        shareModelView(viewModel) {
            this.$emit('shareModelView', viewModel);
        },
    },
    mounted() {},
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.multiViewsTabs >>>
.el-scrollbar__view
  display flex
  flex-direction row
  flex-wrap wrap

.el-scrollbar__wrap
  overflow-x hidden

.el-divider
  margin 12px auto 0

.el-collapse
  margin-top 0

  .el-collapse-item__content
    padding 0

  .el-collapse-item__header
    padding-left 0

    .el-collapse-item__arrow
      margin-left 2px

.views-content
  .viewmodel-card-group
    height 257px

    .viewmodel-img-container
      display flex
      flex-direction column
      justify-content space-between
      width 200px
      height 240px
      margin 10px 25px
      box-shadow #666 0px 0px 5px

      .viewmodel-img-wrapper
        dom_center()
        position relative
        width 200px
        height 200px
        cursor pointer

        .viewmodel-img
          vertical-align middle
          max-width 100%
          max-height 100%

        .viewmodel-img-shadow
          opacity 0
          height 200px
          width 200px
          position absolute
          z-index 10
          background-color rgba(0, 0, 0, 0.7)
          transition all 0.2s

        .viewmodel-img-text
          opacity 0
          width 200px
          dom_center()
          z-index 11
          position absolute
          color $font-btnBlue

        &:hover
          .viewmodel-img-shadow
            opacity 1

          .viewmodel-img-text
            opacity 1

      .viewmodel-img-footer
        dom_center()
        flex 1
        border-top 1px solid $font-grey
        padding 4px

        .viewmodel-img-title
          font-size 16px
          margin-right 4px
          overflow hidden
          white-space nowrap
          text-overflow ellipsis

        .viewmodel-img-share
          .viewmodel-icon:hover
            cursor pointer
            color $font-btnBlue

.empty-state-content
  height 311px
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/components/multiViewsTabs.vue